import { GALLERY_CONSTS, optionsMap } from 'pro-gallery-lib';
export { getDuplicatedCss, isNarrow, isSmallItem, isShort, isVerticalContainer, shouldAddLegacyPaddingBottom };
import { GALLERY_v4_CONSTS } from '..';
function getDuplicatedCss(options) {
  function getInfoHorizontalPadding(options) {
    if (options.imageInfoType === GALLERY_CONSTS.layoutParams_info_layout.SEPARATED_BACKGROUND || options.imageInfoType === GALLERY_CONSTS.layoutParams_info_layout.ATTACHED_BACKGROUND) {
      return options.controllers_layoutParams_info_horizontalPadding + 30;
    }
    return options.controllers_layoutParams_info_horizontalPadding;
  }
  return {
    paddingBottom: options.controllers_layoutParams_info_verticalPadding + 15 + 'px',
    paddingTop: options.controllers_layoutParams_info_verticalPadding + 15 + 'px',
    paddingRight: getInfoHorizontalPadding(options) + 'px',
    paddingLeft: getInfoHorizontalPadding(options) + 'px',
    boxSizing: 'border-box',
    height: '100%'
  };
}
function isNarrow(props) {
  return props.style.width < 200;
}
function isSmallItem(props) {
  const {
    options,
    style
  } = props;
  if (GALLERY_CONSTS.isLayout('SLIDESHOW')(options)) {
    return false;
  }
  let isSmallItem;
  const maxWidth = 90;
  const maxHeight = 90;
  if (options[optionsMap.layoutParams.crop.enable] && options[optionsMap.layoutParams.crop.method] === GALLERY_CONSTS[optionsMap.layoutParams.crop.method].FIT) {
    if (style.orientation === 'landscape') {
      // wide image
      isSmallItem = style.width / style.ratio <= maxHeight;
    } else {
      // tall image
      isSmallItem = style.height * style.ratio <= maxWidth;
    }
  } else {
    isSmallItem = style.width <= maxWidth || style.height <= maxHeight;
  }
  return isSmallItem;
}
function isShort(props) {
  return props.style.height < 150;
}
function isVerticalContainer(props) {
  return props.style.width < props.style.height + 3;
}
function shouldAddLegacyPaddingBottom(props) {
  const options = props.options;
  function allowAnyAction() {
    const {
      options
    } = props;
    return options.loveButton || options.allowSocial || options.allowDownload;
  }
  const textsDisplayOnHover = !GALLERY_CONSTS.isLayout('SLIDESHOW')(options) && !GALLERY_CONSTS.isLayout('SLIDER')(options) && !options[optionsMap.layoutParams.thumbnails.enable] && GALLERY_CONSTS.hasHoverPlacement(options[optionsMap.layoutParams.info.placement]) && options[optionsMap.behaviourParams.item.overlay.hoveringBehaviour] !== GALLERY_CONSTS[optionsMap.behaviourParams.item.overlay.hoveringBehaviour].NEVER_SHOW;
  return textsDisplayOnHover && allowAnyAction() && (options.controllers_layoutParams_info_allowTitle || options.controllers_layoutParams_info_allowTitleAndDescription);
}
//# sourceMappingURL=sharedBetweenMasterAndInfoElement.js.map